import React from 'react';
import { MessageSquare, Mail, Check } from 'lucide-react';

const COLORS = { idle: '#2563eb', checking: '#2563eb', error: '#dc2626', success: '#16a34a' };
const R = 52;
const C = 2 * Math.PI * R;
const SEG = C / 6;
const GAP = 10;

// Segmented ring: one arc per digit, filled as the code is typed.
export default function CodeRing({ filled, status, channel }) {
  const color = COLORS[status];
  const all = status === 'error' || status === 'success';
  return (
    <div className={`relative w-32 h-32 mx-auto ${status === 'error' ? 'animate-shake' : ''}`}>
      <svg viewBox="0 0 120 120" className={`w-full h-full -rotate-90 ${status === 'checking' ? 'animate-[spin_1.4s_linear_infinite]' : ''}`}>
        <circle cx="60" cy="60" r="58" fill="none" stroke={color} strokeWidth="1.5" opacity="0.35" style={{ transition: 'stroke .3s' }} />
        {Array.from({ length: 6 }).map((_, i) => (
          <circle
            key={i}
            cx="60" cy="60" r={R} fill="none" strokeWidth="5" strokeLinecap="round"
            stroke={all || i < filled ? color : '#e5e7eb'}
            strokeDasharray={`${SEG - GAP} ${C - SEG + GAP}`}
            strokeDashoffset={-(i * SEG + GAP / 2)}
            style={{ transition: 'stroke .3s ease' }}
          />
        ))}
      </svg>
      <div className="absolute inset-0 flex items-center justify-center" style={{ color }}>
        {status === 'success'
          ? <Check key="ok" className="w-9 h-9 animate-pop" strokeWidth={2.5} />
          : channel === 'email' ? <Mail className="w-7 h-7" /> : <MessageSquare className="w-7 h-7" />}
      </div>
    </div>
  );
}